
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordChange = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [changeStatus, setChangeStatus] = useState(null);
  const { isAuthenticated, userId, logout, token } = useAuth();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
    }
  }, [isAuthenticated, token, logout]);

  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const validatePassword = () => {
    // Password must be at least 8 characters long
    if (newPassword.length < 8) {
      setErrorMessage('Password must be at least 8 characters long.');
      return false;
    }

    // Password must contain at least one uppercase letter
    if (!/[A-Z]/.test(newPassword)) {
      setErrorMessage('Password must contain at least one uppercase letter.');
      return false;
    }

    // Password must contain at least one lowercase letter
    if (!/[a-z]/.test(newPassword)) {
      setErrorMessage('Password must contain at least one lowercase letter.');
      return false;
    }

    // Password must contain at least one digit
    if (!/\d/.test(newPassword)) {
      setErrorMessage('Password must contain at least one digit.');
      return false;
    }

    // Passwords must match
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return false;
    }

    // Password is valid
    setErrorMessage('');
    return true;
  };

  const handleChangePassword = async () => {
    // if (!validatePassword()) {
    //   // Password validation failed
    //   return;
    // }

    const createData = {
      CurrentPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
      UserId: userId,
    };

    updateData('UserTokenApi', `${userId}`, createData, token)
      .then((response) => {
        setSuccessMessage(response.message);
        if (response.responseCode === '1111') {
          logout();
        }

      })
      .catch((error) => {
        setSuccessMessage('');
        console.error('Password Change error:', error);
      });
  };

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // const styles = {
  //   container: { padding: '20px', maxWidth: '400px', margin: 'auto' },
  //   title: { fontSize: '24px', marginBottom: '20px' },
  //   label: { display: 'block', marginBottom: '10px', fontWeight: 'bold' },
  //   input: { width: '100%', padding: '8px', marginBottom: '15px', border: '1px solid #ccc' },
  //   button: { padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', cursor: 'pointer' },
  //   status: { marginTop: '10px', color: 'green' },
  // };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Password Change</h3>

      <label style={styles.label} htmlFor="oldPassword">
        Old Password:
      </label>
      <div style={{ position: 'relative' }}>
        <input
          type={showOldPassword ? 'text' : 'password'}
          id="oldPassword"
          value={oldPassword}
          onChange={handleOldPasswordChange}
          style={styles.input}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={() => setShowOldPassword(!showOldPassword)}
        >
          {showOldPassword ? <FaEyeSlash style={{ color: 'red' }} /> : <FaEye style={{ color: 'darkblue' }} />}
        </span>
      </div>

      <label style={styles.label} htmlFor="newPassword">
        New Password:
      </label>
      <div style={{ position: 'relative' }}>
        <input
          type={showNewPassword ? 'text' : 'password'}
          id="newPassword"
          value={newPassword}
          onChange={handleNewPasswordChange}
          style={styles.input}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={() => setShowNewPassword(!showNewPassword)}
        >
          {showNewPassword ? <FaEyeSlash style={{ color: 'red' }} /> : <FaEye style={{ color: 'darkblue' }} />}
        </span>
      </div>

      <label style={styles.label} htmlFor="confirmPassword">
        Confirm Password:
      </label>
      <div style={{ position: 'relative' }}>
        <input
          type={showConfirmPassword ? 'text' : 'password'}
          id="confirmPassword"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          style={styles.input}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        >
          {showConfirmPassword ? <FaEyeSlash style={{ color: 'red' }} /> : <FaEye style={{ color: 'darkblue' }} />}
        </span>
      </div>

      <button onClick={handleChangePassword} style={styles.button}>
        Change Password
      </button>

      <div className="watermark" style={{ marginTop: '20px', textAlign: 'center' }}>
        <b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: 'auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    marginTop: '3%'
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '20px',
    color: 'darkblue',
    fontFamily: 'italic',
    textAlign: 'center'

  },
  label: {
    display: 'block',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '8px',
    marginBottom: '15px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },

  button: {
    // backgroundColor: '#6A9C89',
    backgroundColor: '#C68484',
    height: '40px',
    width: '54.5%',
    marginLeft: '20%',
    padding: '8px 16px',
    borderRadius: '6px',
    fontWeight: 'bold',
    boxShadow: 'inset 0px 4px 6px rgba(255, 255, 255, 0.3), 0px 6px 10px rgba(0, 0, 0, 0.2)', // Inner and outer shadows
    border: '1px solid rgb(226, 229, 232)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    pointer: 'cursor',
    color: 'whitesmoke'
  },
  status: {
    marginTop: '15px',
    fontSize: '14px',
    color: '#007bff',
  },
};

export default PasswordChange;
